import { Box, Tag, chakra } from "@chakra-ui/react";
import { useState } from "react";

interface MultipleInputProps {
  values: string[];
  setValues: (values: string[]) => void;
  placeholder: string;
}

const MultipleInput: React.FC<MultipleInputProps> = ({
  values,
  setValues,
  placeholder,
}) => {
  const [value, setValue] = useState("");

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      if (!value.trim()) return;
      const existing = values.find((v) => v.trim() === value.trim());
      if (existing) return;
      setValues([...values, value.trim()]);
      setValue("");
    }
  };
  return (
    <Box
      mt={4}
      borderWidth="1px"
      borderColor="border"
      borderRadius="md"
      p={2}
      display="flex"
      flexWrap="wrap"
      alignItems="center"
      gap={1}
      _focusWithin={{
        borderColor: "brand.500",
        boxShadow: "0 0 0 1px var(--chakra-colors-brand-500)",
      }}
    >
      {values.map((email) => (
        <Tag.Root key={email} colorPalette="brand" size="md">
          <Tag.Label>{email}</Tag.Label>
          <Tag.EndElement>
            <Tag.CloseTrigger
              onClick={() => setValues(values.filter((v) => v !== email))}
            />
          </Tag.EndElement>
        </Tag.Root>
      ))}

      <chakra.input
        flex="1"
        minW="160px"
        px={2}
        py={1}
        bg="transparent"
        border="none"
        outline="none"
        fontSize="sm"
        placeholder={placeholder}
        type="email"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
      />
    </Box>
  );
};

export default MultipleInput;
